import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect } from 'react';
import logger from 'loglevel';
import { DateISODto } from '@beefco/types';
import { InitLocalPageCommand, InitLocalProjectCommand, RequestLibraryCommand,
// SetPageCommand,
SetStoragePageCommand, SynchronizeStateCommand, useEventTransmitter } from '@beefco/sdk-tools';
import { useGlobalBridge, useNodeRectAfterSync } from '@beefco/bridge';
import { useBeefCoExtSdk, useBeefCoPage, useBeefCoProject } from '@beefco/sdk-shared';
import { extendNode } from "../utils/extendNode";
import { useUpdateLocalProject } from "./useUpdateLocalProject";

// TODO: separate subscription to globalBridge

var IS_PRODUCTION = process.env.NODE_ENV === 'production';

// TODO: возможно для локального режима и для прод режима нужно собирать и вызывать разные хуки?
//   а еще лучше разбить инициализацию на 3 части - client, prod-platform, local-platform
export var useAdminConnector = function useAdminConnector(_ref) {
  var pageId = _ref.pageId,
    pageSlug = _ref.pageSlug,
    libraryDSL = _ref.libraryDSL,
    libraryRootPath = _ref.libraryRootPath;
  var globalBridge = useGlobalBridge();
  var _useBeefCoExtSdk = useBeefCoExtSdk(),
    setExtendNode = _useBeefCoExtSdk.setExtendNode,
    setGlobalBridge = _useBeefCoExtSdk.setGlobalBridge;
  var _useBeefCoProject = useBeefCoProject(),
    config = _useBeefCoProject.config;
  var _useBeefCoPage = useBeefCoPage(),
    coreDSL = _useBeefCoPage.coreDSL,
    setCoreDSL = _useBeefCoPage.setCoreDSL,
    hardcodedLibraryDSL = _useBeefCoPage.libraryDSL,
    hardcodeConfig = _useBeefCoPage.config;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isConnected = _React$useState2[0],
    setConnected = _React$useState2[1];
  useEventTransmitter();
  useNodeRectAfterSync();
  useUpdateLocalProject({
    pageSlug: pageSlug,
    pageId: pageId
  });

  // TODO: rewrite update core dsl and request library to some start-up/initialize event
  var updateLibraryDSL = useCallback(function () {
    /**
     * TODO: в будущем может потребоваться тестировать прод-режим
     *   в dev + hot-reload, но через реальный сайт
     */
    if (!IS_PRODUCTION) {
      if (!import.meta.webpackHot) {
        console.warn('Проект запущен в development режиме, однако hmr не настроен');
      }
      globalBridge.bus.execute(new InitLocalProjectCommand({
        pageId: pageId,
        pageSlug: pageSlug,
        coreDSL: coreDSL,
        libraryDSL: libraryDSL,
        libraryRootPath: libraryRootPath,
        config: config,
        updatedAt: DateISODto.toPlain(new Date())
      }));
    } else {
      // todo: временное редактирование в localStorage
      if (!coreDSL || !hardcodedLibraryDSL) return;
      globalBridge.bus.execute(new SetStoragePageCommand({
        pageId: pageId,
        pageSlug: pageSlug,
        coreDSL: coreDSL,
        config: config || hardcodeConfig || null,
        libraryDSL: hardcodedLibraryDSL
      }));
      // todo: Пока не работает
      // globalBridge.bus.execute(
      //   new SetPageCommand({
      //     pageId,
      //     pageSlug,
      //   }),
      // );
    }
  }, [config, coreDSL, globalBridge.bus, hardcodeConfig, hardcodedLibraryDSL, libraryDSL, libraryRootPath, pageId, pageSlug]);
  var initHardcodeLibraryDSL = useCallback(function () {
    if (!hardcodedLibraryDSL || IS_PRODUCTION) return;
    globalBridge.bus.execute(new InitLocalPageCommand({
      pageId: pageId,
      pageSlug: pageSlug,
      coreDSL: coreDSL,
      libraryDSL: hardcodedLibraryDSL,
      config: config,
      updatedAt: DateISODto.toPlain(new Date())
    }));
  }, [config, coreDSL, globalBridge.bus, hardcodedLibraryDSL, pageId, pageSlug]);
  React.useEffect(function () {
    if (window.parent !== window) {
      globalBridge.frameBroker.connect(window.parent,
      /**
       * FIXME: URL есть у platform-gui & platform, но нет у project.
       *  Нужна иная схема передачи, это может быть шифрование асинхронными ключами например:
       *  https://babeljs.io/docs/babel-plugin-transform-inline-environment-variables
       */
      '*');
      globalBridge.frameBroker.onReady(function () {
        initHardcodeLibraryDSL();
        updateLibraryDSL();
        // @ts-expect-error FIXME: can't fix that, some jibbrish with IntristicAttributes
        setExtendNode(extendNode);
        setGlobalBridge(globalBridge);
        setConnected(true);
        globalBridge.bus.on(SynchronizeStateCommand, function (_ref2) {
          var newCoreDSL = _ref2.coreDSL;
          logger.info('Updating core via back office');
          setCoreDSL(newCoreDSL);
        });
        globalBridge.bus.on(RequestLibraryCommand, function () {
          /**
           * TODO: Figure out if this approach is okay
           * Key points: server restart is something that may only happen in development mode
           * But maybe this whole bridge is only required in development?
           * As for production, json is simply going to be bundled in
           */
          updateLibraryDSL();
        });
      });
    }
  }, []);
  useEffect(function () {
    updateLibraryDSL();
  }, [libraryDSL]);
  return {
    isConnected: isConnected,
    coreDSL: coreDSL
  };
};